export const EmptyState = () => (
  <svg width="135" height="133" viewBox="0 0 135 133" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3074_191300)">
      <mask
        id="mask0_3074_191300"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-4"
        y="-5"
        width="144"
        height="143"
      >
        <ellipse cx="67.9427" cy="66.4997" rx="71.4667" ry="70.9333" fill="url(#paint0_radial_3074_191300)" />
      </mask>
      <g mask="url(#mask0_3074_191300)">
        <g opacity="0.8">
          <mask
            id="mask1_3074_191300"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="-474"
            y="-346"
            width="1377"
            height="977"
          >
            <g clipPath="url(#clip1_3074_191300)">
              <line x1="7.25342" y1="-346.658" x2="7.25338" y2="630.123" stroke="#D1E4FA" />
              <line x1="23.2534" y1="-346.658" x2="23.2534" y2="630.123" stroke="#D1E4FA" />
              <line x1="39.2539" y1="-346.658" x2="39.2539" y2="630.123" stroke="#D1E4FA" />
              <line x1="55.2539" y1="-346.658" x2="55.2539" y2="630.123" stroke="#D1E4FA" />
              <line x1="71.2539" y1="-346.658" x2="71.2539" y2="630.123" stroke="#D1E4FA" />
              <line x1="87.2539" y1="-346.658" x2="87.2539" y2="630.123" stroke="#D1E4FA" />
              <line x1="103.254" y1="-346.658" x2="103.254" y2="630.123" stroke="#D1E4FA" />
              <line x1="119.254" y1="-346.658" x2="119.254" y2="630.123" stroke="#D1E4FA" />
              <line x1="135.254" y1="-346.658" x2="135.254" y2="630.123" stroke="#D1E4FA" />
              <line x1="-473.248" y1="5.8418" x2="902.752" y2="5.8418" stroke="#D1E4FA" />
              <line x1="-473.248" y1="21.8418" x2="902.752" y2="21.8418" stroke="#D1E4FA" />
              <line x1="-473.248" y1="37.8418" x2="902.752" y2="37.8418" stroke="#D1E4FA" />
              <line x1="-473.248" y1="53.8418" x2="902.752" y2="53.8418" stroke="#D1E4FA" />
              <line x1="-473.248" y1="69.8418" x2="902.752" y2="69.8418" stroke="#D1E4FA" />
              <line x1="-473.248" y1="85.8418" x2="902.752" y2="85.8418" stroke="#D1E4FA" />
              <line x1="-473.248" y1="101.842" x2="902.752" y2="101.842" stroke="#D1E4FA" />
              <line x1="-473.248" y1="117.842" x2="902.752" y2="117.842" stroke="#D1E4FA" />
            </g>
          </mask>
          <g mask="url(#mask1_3074_191300)">
            <ellipse cx="63.9426" cy="68.4988" rx="59.1902" ry="59.0652" fill="#D1E4FA" />
          </g>
          <path
            opacity="0.5"
            d="M132.812 65.3508C132.812 101.017 103.837 129.932 68.093 129.932C32.3487 129.932 3.37402 101.017 3.37402 65.3508C3.37402 29.6846 32.3487 0.769531 68.093 0.769531C103.837 0.769531 132.812 29.6846 132.812 65.3508Z"
            stroke="#B0D0F6"
          />
        </g>
      </g>
      <path
        d="M42.5796 72.8629L61.6791 55.8254L75.4729 66.3484L94.307 50.0625"
        stroke="#82D9AA"
        strokeWidth="2"
        strokeLinejoin="round"
        strokeDasharray="4 4"
      />
      <line
        x1="38.6489"
        y1="46.0996"
        x2="38.6489"
        y2="84.9399"
        stroke="#95C0F4"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="98.2368"
        y1="85.7305"
        x2="38.6489"
        y2="85.7305"
        stroke="#95C0F4"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect x="67.6406" y="34.7793" width="1.30835" height="7.40784" rx="0.654176" fill="#82D9AA" />
      <rect
        width="1.29994"
        height="7.46092"
        rx="0.649972"
        transform="matrix(0.945788 0.324784 -0.35992 0.932983 73.5459 35.7168)"
        fill="#82D9AA"
      />
      <rect
        width="1.29994"
        height="7.46092"
        rx="0.649972"
        transform="matrix(0.945788 -0.324784 0.35992 0.932983 61.7695 36.1406)"
        fill="#82D9AA"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_3074_191300"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.9427 66.4997) rotate(90) scale(63.5444 64.0222)"
      >
        <stop offset="0.65" />
        <stop offset="0.9999" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_3074_191300">
        <rect width="134" height="133" fill="white" transform="translate(0.942871)" />
      </clipPath>
      <clipPath id="clip1_3074_191300">
        <rect width="1376" height="976" fill="white" transform="translate(-473.248 -345.658)" />
      </clipPath>
    </defs>
  </svg>
);
